import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const hazmatUnsAdapter = getAdapter();

const hazmatUnsSlice = createSlice({
    name: 'hazmatUns',
    initialState: hazmatUnsAdapter.getInitialState(),
    reducers: {
        setHazmatUns: (state, { payload: { hazmatUns } }) => {
            hazmatUnsAdapter.setAll(state, hazmatUns);
        },
    },
});

const selectors = hazmatUnsAdapter.getSelectors(({ hazmatUns }) => hazmatUns);

export const getAllhazmatUns = (state) => selectors.selectAll(state);

export const {
    setHazmatUns,
} = hazmatUnsSlice.actions;

export default hazmatUnsSlice.reducer;
